import { css } from '@emotion/core';
import { applyFont, media, rgba, tokens, variables } from '@domain-group/fe-brary';
import { typography as designSystemTypography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
var headingM = designSystemTypography.headingM,
  body = designSystemTypography.body,
  bodyLongBold = designSystemTypography.bodyLongBold,
  bodyLong = designSystemTypography.bodyLong;
var colors = tokens.colors,
  typography = tokens.typography;
export var container = {
  name: "1c7a3ef",
  styles: "position:relative;padding:24px 0;user-select:none;margin-bottom:10px;"
};
export var header = {
  name: "70qvj9",
  styles: "display:flex;align-items:center;"
};
export var heading = /*#__PURE__*/css("display:none;", media('>=tablet'), "{display:block;", applyFont(typography.heading), ";color:", colors.neutral.heavy.default, ";}");
export var headingMobile = /*#__PURE__*/css("display:block;", applyFont(typography.heading), ";color:", colors.neutral.heavy.default, ";", media('>=tablet'), "{display:none;}");
export var headerDivider = /*#__PURE__*/css("width:20px;height:0px;transform:rotate(-90deg);opacity:1;border-width:1px;border:1px solid ", colors.neutral.trim.default, ";");
export var modalFooter = /*#__PURE__*/css("display:flex;width:100%;height:100%;padding:0 16px;align-items:center;justify-content:center;", media('>=tablet'), "{justify-content:space-between;}");
export var modalFooterButton = /*#__PURE__*/css(media('<tablet'), "{display:none;}");
export var card = {
  name: "1jbawm2",
  styles: "margin:16px 0;"
};
export var cardTitle = /*#__PURE__*/css(headingM, ";margin-bottom:8px;color:", colour.neutral900, ";");
export var cardSubtitle = /*#__PURE__*/css(body, ";margin-bottom:8px;color:", colour.neutral700, ";");
export var cardSubtitlePrefix = {
  name: "1bpvmlm",
  styles: "padding-right:12px;"
};
export var cardSubtitleSuffix = {
  name: "vxcmzt",
  styles: "display:inline-flex;"
};
export var cardMessage = /*#__PURE__*/css(bodyLong, ";position:relative;height:48px;overflow:hidden;margin:0;&:after{content:'... more';position:absolute;right:0;bottom:0;width:220px;color:", colour.secondary, ";background:linear-gradient( 270deg,", colour.neutral100, " 40%,", rgba(colour.neutral100, 0), " );padding:0 12px 0 8px;text-align:right;", bodyLongBold, ";margin:0;}", media('>=tablet'), "{height:24px;}");
export var loader = _ref => {
  var appear = _ref.appear;
  return /*#__PURE__*/css("display:flex;justify-content:center;height:", appear ? '64px' : '0px', ";transition:height 0.3s;overflow:hidden;");
};
export var errorMessage = {
  name: "1xhj18k",
  styles: "display:flex;flex-direction:row;"
};
export var alertIcon = {
  name: "35aww8",
  styles: "flex-shrink:0;margin:0 16px 16px;"
};